import { render, staticRenderFns } from "./ServiceClientAccessRights.vue?vue&type=template&id=1b452c32&scoped=true&"
import script from "./ServiceClientAccessRights.vue?vue&type=script&lang=ts&"
export * from "./ServiceClientAccessRights.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceClientAccessRights.vue?vue&type=style&index=0&id=1b452c32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b452c32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
